<div
  align="center"
  style="text-align: left; margin-top: 15px; margin-left: 2vw"
>
  <div
    fxLayout.s="column"
    fxLayout="row wrap"
    fxLayoutGap="10px"
    ngClass.gt-xs="ml-1"
    style="margin-left: 2vw; margin-top: 15px"
  >
    <mat-card
      fxFlex.sm="0 1 calc(50%-10px)"
      fxFlex.md="0 1 calc(33%-10px)"
      fxFlex.gt-md="0 1 calc(25%-10px)"
    >
      <mat-card-subtitle>
        Información de las entradas de datos:
      </mat-card-subtitle>
      <mat-card-content>
        <h5><b>Nombre del Source: </b> {{ nombreActual }}</h5>
        <h5 *ngIf="dispositivoActual">
          <b>Dispositivo del source: </b> {{ dispositivoActual }}
        </h5>
      </mat-card-content>
    </mat-card>

    <mat-card
      fxFlex.sm="0 1 calc(50%-10px)"
      fxFlex.md="0 1 calc(33%-10px)"
      fxFlex.gt-md="0 1 calc(25%-10px)"
    >
      <mat-card-subtitle>
        Información de las alarmas del nodo
      </mat-card-subtitle>
      <mat-card-content>
        <mat-icon
          class="alarms"
          [matBadge]="alarmsCount"
          (click)="openAlertsComponent('alarmado')"
          title="Incidencias alarmadas en la estructura"
          >new_releasess</mat-icon
        >
        <!-- <span matBadge="{{ alarmsCount }}" matBadgeOverlap="true" style="margin-top: -15px;"></span> -->

        <mat-icon
          class="notifications-off"
          [matBadge]="silenciadosCount"
          (click)="openAlertsComponent('silenciado')"
          title="Incidencias silenciadas en la estructura"
        >
          notifications_off</mat-icon
        >

        <mat-icon
          class="other-alarms"
          (click)="rearmaAlarmaNodo()"
          title="Otras incidencias"
        >
          notifications_active</mat-icon
        >
      </mat-card-content>
    </mat-card>

    <mat-card
      *ngIf="isMBDevice == true"
      fxFlex.sm="0 1 calc(50%-10px)"
      fxFlex.md="0 1 calc(33%-10px)"
      fxFlex.gt-md="0 1 calc(25%-10px)"
    >
      <mat-card-subtitle>
        <h4>Selección de medidas para tiempo real</h4>
      </mat-card-subtitle>
      <mat-card-content>
        <mat-form-field>
          <mat-label>Tipo de medición</mat-label>
          <mat-select
            multiple
            (selectionChange)="createRT($event.value)"
            placeholder="Seleccionar mediciones..."
          >
            <!-- <input (keyup)="onKey($event.target.value)" (keydown)="$event.stopPropagation()"
                            placeholder="Filtrar..."> -->
            <!-- <mat-option>Ninguno</mat-option>-->
            <mat-option *ngFor="let r of registers" [value]="r">{{
              r.descripcion
            }}</mat-option>
            <!-- <cdk-virtual-scroll-viewport [itemSize]="24" [style.height.px]=12*24>
                            <mat-option style="height: 48px" *cdkVirtualFor="let r of registers" [value]="r"> 
                                {{r.descripcion }}
                            </mat-option> 
                        </cdk-virtual-scroll-viewport>-->
          </mat-select>
        </mat-form-field>
      </mat-card-content>
    </mat-card>
  </div>
</div>

<br />
<br />

<div [hidden]="mqttTopicsRT.length < 1" style="margin-left: 2vw">
  <h4 align="center">Tiempo real</h4>

  <mat-grid-list cols="2" rowHeight="600px">
    <mat-grid-tile
      *ngFor="let sub of mqttTopicsRT; index as i"
      [colspan]="1"
      [rowspan]="1"
    >
      <mat-card>
        <div align="center">
        <mat-card-subtitle>
          <span align="center"><h3>{{ sub.descripcion }}</h3></span>
        </mat-card-subtitle>
      </div>
        <mat-card-content>
          <app-rt-graphics
            [dataTraces]="mqttTopicsRT"
            [data]="sub"
            [layout]="configRT.layout"
            [config]="configRT.config"
          >
          </app-rt-graphics>
        </mat-card-content>
      </mat-card>
    </mat-grid-tile>
  </mat-grid-list>
</div>

<br />

<div style="text-align: left" class="row">
  <a
    style="margin-left: 2vw; cursor: pointer; margin-top: 15px"
    (click)="previousState()"
  >
    <i class="material-icons">chevron_left</i>
  </a>
</div>
<br />

<mat-form-field class="filtro-tabla">
  <mat-label>Filtrar</mat-label>
  <input
    matInput
    (keyup)="applyFilter($event)"
    placeholder="Filtrar datos..."
  />
</mat-form-field>

<div
  class="mat-elevation-z8"
  style="width: 85%; margin-left: 2vw"
  align="center"
  [hidden]="!dataSource"
>
  <table mat-table [dataSource]="dataSource">
    <ng-container matColumnDef="topic">
      <th mat-header-cell *matHeaderCellDef><b>Nombre</b></th>
      <td mat-cell *matCellDef="let d; let i = index">
        <span
          *ngIf="d.alarmadosCount"
          matBadge="{{ d.alarmadosCount }}"
          matBadgeOverlap="false"
          ><i class="material-icons alarm">new_releases</i></span
        >
        <a
          style="padding-left: 25px"
          title="Navegar al dato &quot;{{
            d.data.node.esConnection.edges[0].node.descripcion
          }}&quot;"
          [routerLink]="['/dato', d.data.node.uuid]"
        >
          {{ d.data.topic ? d.data.topic : "Sin topic definido" }}
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="descripcion">
      <th mat-header-cell *matHeaderCellDef><b>Descripción</b></th>
      <td mat-cell *matCellDef="let d">
        <div style="width: 85%; word-wrap: break-word">
          <span *ngFor="let td of d.data.node.esConnection.edges">
            {{ td.node.descripcion }}
          </span>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="last">
      <th mat-header-cell *matHeaderCellDef><b>Entrada del último dato</b></th>
      <td mat-cell *matCellDef="let d">
        {{ d.data.last | getDatePipe }}
        <span *ngIf="!d.data.lastFecha">
          <i class="material-icons warning" title="No hay fecha registrada">
            error
          </i>
        </span>
      </td></ng-container
    >

    <ng-container matColumnDef="lastFecha">
      <th mat-header-cell *matHeaderCellDef><b>Envío del último dato</b></th>
      <td mat-cell *matCellDef="let d">
        {{ d.data.lastFecha | getDatePipe }}
        <span *ngIf="!d.data.lastFecha">
          <i class="material-icons warning" title="No hay fecha registrada">
            error
          </i>
        </span>
      </td></ng-container
    >

    <ng-container matColumnDef="lastValor">
      <th mat-header-cell *matHeaderCellDef><b>Último valor registrado</b></th>
      <td mat-cell *matCellDef="let d">
        {{ d.data.lastValor | getToFixed }}
        <span *ngIf="!d.data.lastValor">
          <i class="material-icons warning" title="No hay valor registrado">
            error
          </i>
        </span>
      </td></ng-container
    >

    <ng-container matColumnDef="unidad">
      <th mat-header-cell *matHeaderCellDef><b>Unidad asociada</b></th>
      <td mat-cell *matCellDef="let d">
        {{ d.data.node.esConnection?.edges[0].node.nombre }}
      </td></ng-container
    >

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row
      class="pre"
      *matRowDef="let row; columns: displayedColumns"
    ></tr>
    <!-- [ngClass]="{'trError': (row.alarmadosCount > 0), 'trWarning' : (row.silenciadosCount >0)}"          -->
  </table>
  <mat-paginator [pageSizeOptions]="[15, 30, 50]" showFirstLastButtons>
  </mat-paginator>
</div>

<br />
